import { useQuery } from "@tanstack/react-query";
import getExtensionSettings from "services/getSettings"
import getSiteSettingsByKey from "services/getSiteSettingsByKey"

export const useSettings = () => {
    const { data } = useQuery(["settings"], getExtensionSettings)
    return { settings: data }
}

export const useSiteSettingsByKey = (payload: any) => {
    return useQuery({queryKey:['getSiteSettingsByKey', payload], queryFn: ()=>getSiteSettingsByKey(payload)});
};